import { lazy } from 'react';

const Empresa = lazy(() => import('../components/Empresa'));
const Dashboard = lazy(() => import('../components/Dashboard'));
const DocumentoFiscal = lazy(() => import('../components/DocumentoFiscal'));
const Detalhes = lazy(() => import('../components/DocumentoFiscal/Detalhes'));
const EnviarDocumento = lazy(() => import('../components/EnviarDocumento'));
const GestaoDeChaves = lazy(() => import('../components/GestaoDeChaves'));
const FilaChaves = lazy(() => import('../components/FilaChaves'));
const HistoricoConsulta = lazy(() => import('../components/HistoricoDeConsultas/PortalNacional'));
const HistoricoConsultaPortalEstadual = lazy(() =>
  import('../components/HistoricoDeConsultas/PortalEstadual'),
);
const Manifesto = lazy(() => import('../components/Manifesto'));
const NaoAutorizado = lazy(() => import('../components/NaoAutorizado'));
const Configuracoes = lazy(() => import('../components/Configuracoes'));
const DocumentosBloqueados = lazy(() => import('../components/DocumentosBloqueados'));

const RouteComponents = {
  '/acesso-nao-autorizado': NaoAutorizado,
  '/dashboards': Dashboard,
  '/empresas': Empresa,
  '/documentos-fiscais': DocumentoFiscal,
  '/documentos-fiscais/:id': Detalhes,
  '/enviar-documentos': EnviarDocumento,
  '/gestao-chaves': GestaoDeChaves,
  '/fila-chaves': FilaChaves,
  '/historicos-consulta': HistoricoConsulta,
  '/historicos-consulta-portal-estadual': HistoricoConsultaPortalEstadual,
  '/manifestos': Manifesto,
  '/configuracoes': Configuracoes,
  '/documentos-bloqueados': DocumentosBloqueados,
};

export default RouteComponents;
